import { IHtmlLayout } from '../../types/layout/html';

function Html({ content }: IHtmlLayout) {
    return (
        <div dangerouslySetInnerHTML={{ __html: content }} />
    );
}

export default Html;
